const Quant = {
    topic: 'quantitative',
    level: 'Beginner',
    totalQuestions: 10,
    perQuestionScore: 1,
    questions: [
        {
             question:  ' A Square shaped table has a length of 44.5cm. Can you find the Perimeter of the same',
             choices: ['180 cm','176.5 cm', '178 cm','160.2 cm','None of These'],
             type: 'MCQs',
             correctAnswer: '178 cm',
            },
      
            {
              question: 'The Sum of all even nos. from 1 to 30 is',
              choices: ['398', '240', '372', '441', '450'],
              type: 'MCQs',
              correctAnswer: '240',
              },
              
              {
              question: 'A train travels from City A to City B at a speed of 56 kmph, while on its return journey the train was travelling at speed of 67 kmph. Find the average speed of the train.',
              choices: ['58', '58.5', '61.5', '60.5', 'None of these'],
              type: 'MCQs',
              correctAnswer: '61.5',
              },
              
              {
              question: 'A bag contains money, 100 rupees, 20 rupees and 10 rupees in the proportion 2:5:9. If the total amount is Rs. 390, find the number of notes of each kind?',
              choices: ['2, 5, 8', '3, 9, 9', '5, 3, 7', '3, 4, 8', '2, 5, 9'],
              type: 'MCQs',
              correctAnswer: '2,5,9',
              },
              
              {
              question: 'A pipe can fill ¾ of a water tank in 48 minutes. In how many minutes can it fill ½ of a jar?',
              choices: ['30 ¾ mins', '32 mins', '30 mins', '34 mins','20mins'],
              type: 'MCQs',
              correctAnswer: '32 mins',
              },
              
              {
              question: 'Can you find the answer for the below equation 2 + 18 * 11 - 32/ 13',
              choices: ['173.24', '170.24', '177.24', '179.24', '197.54'],
              type: 'MCQs',
              correctAnswer: '177.24',
              },
              
              {
              question: 'Read the statements and decide whether the data provided in the statements are sufficient to answer the question. What is the profit percentage if a discount of 10% is offered on an article? , I. Had there been no discount offered, the profit earned on the sale of the article would be 40%. II. The discount offered on the article is 14% of the cost price. III. The cost price of the article is Rs.1000.',
              choices: ['If the data in statement I alone are sufficient', 'If the data either in statement I alone or statement II alone are sufficient to answer', 'All I, II & III together are required to answer',  'Each statement alone is sufficient to answer' ,  'None of the above' ],
              type: 'MCQs',
              correctAnswer: 'If the data either in statement I alone or statement II alone are sufficient to answer',
              },
              
              {
                question: 'If 12x =84, then x is equal to',
                choices: ['14','8','12','7','9'],
                type: 'MCQs',
                correctAnswer:'7',
              },
      
              {
              question: 'The ages (in years) of Ram and Shyam are the ratio of 5:7. If Shyam was 10 years older and Ram 10 years younger i.e. post 10 years, the age of Ram would have been same the current age of Shyam. What is Rams age',
              choices:['25 years','17 years', '23 years',  '21 years', '12years'],
              type: 'MCQs',
              correctAnswer:'25 years',
              },
              
              {
                question: ' How many numbers from 1 to 100 are there each of which is not exactly divisible by 3, but also has 3 as a digit',
                choices: ['7','18','21','12','19'],
                type: 'MCQs',
                correctAnswer: '12',
              },            
    ],
  }

export default Quant